var _path, _path2, _path3, _path4, _path5, _path6, _defs;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgGraduationCap(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 50,
    height: 37,
    viewBox: "0 0 50 37",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M40.144 16.424v12.558c0 2.857-6.5 7.768-14.516 7.768-8.017 0-14.517-4.91-14.517-7.768V16.424h29.033z",
    fill: "url(#wqegmywdua)"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M40.144 26.005v2.977c0 2.857-6.5 7.768-14.516 7.768-8.017 0-14.517-4.911-14.517-7.768v-2.977c0 2.856 6.5 7.767 14.517 7.767 8.016 0 14.516-4.91 14.516-7.767z",
    fill: "#707070"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M40.144 16.424v1.873L26.037 24.63a1 1 0 0 1-.82 0l-14.106-6.333v-1.873h29.033z",
    fill: "#8B8B8B"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M26.035 22.757a1 1 0 0 1-.82 0L2.659 12.633c-.788-.354-.788-1.472 0-1.825L25.216.684a1 1 0 0 1 .819 0l22.557 10.124c.788.353.788 1.471 0 1.825L26.035 22.757z",
    fill: "url(#ufxfqcomtb)"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M42.562 31.572V15.889L25.48 12.583a.816.816 0 0 1-.528-.362.926.926 0 0 1-.133-.656.885.885 0 0 1 .338-.565.777.777 0 0 1 .613-.143l17.742 3.453a.798.798 0 0 1 .479.301.901.901 0 0 1 .182.562v16.399a.895.895 0 0 1-.236.61.78.78 0 0 1-.57.253.781.781 0 0 1-.57-.253.895.895 0 0 1-.236-.61z",
    fill: "url(#j41yowypmc)"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "m45.244 33.298.54 3.452h-4.839l.54-3.452c.072-.478.301-.913.645-1.227a1.83 1.83 0 0 1 1.235-.486c.452 0 .89.172 1.234.486s.573.749.645 1.227z",
    fill: "url(#3vvg3z365d)"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "wqegmywdua",
    x1: 25.628,
    y1: 16.424,
    x2: 25.628,
    y2: 36.75,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#AAA9A9"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#8B8B8B"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "ufxfqcomtb",
    x1: 25.625,
    y1: 0.5,
    x2: 25.625,
    y2: 22.941,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#707070"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#AEABAB"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "j41yowypmc",
    x1: 34.497,
    y1: 32.426,
    x2: 34.497,
    y2: 10.857,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F36E21"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#F79A64"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "3vvg3z365d",
    x1: 43.365,
    y1: 36.75,
    x2: 43.365,
    y2: 31.572,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F36E21"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#F79A64"
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgGraduationCap);
export default __webpack_public_path__ + "static/media/graduation-cap.228238ace61b5d87b0c262e856e0a8f7.svg";
export { ForwardRef as ReactComponent };